import { Authority } from '@app/shared/utils/enums';

export abstract class BaseComponent { 
    Authority: any = Authority;

    constructor() {}
}